<template>
  <router-view />
</template>

<script>
export default {
  name: "app-numberRange"
};
</script>

<style lang="scss" scoped></style>
